import request from '@/utils/request'


//中转仓分配
// 中转仓分配列表
export function warehouseOorderList(data) {
  return request({
    url: '/warehouse/order/list',
    method: 'post',
    data
  })
}


// 中转仓分配列表 导出
export function warehouseOorderListExport(data) {
  return request({
    url: '/warehouse/order/export',
    method: 'post',
    data,
    responseType: 'arraybuffer'
  })
}

// 中转仓确认
export function warehouseConfirm(data) {
    return request({
      url: '/warehouse/confirm',
      method: 'post',
      data
    })
  }

//   旧的发车
export function warehouseStart(data) {
    return request({
      url: '/warehouse/start',
      method: 'post',
      data
    })
  }

//新发车兼容未发货的分配司机
export function assignDriver(data) {
  return request({
    url: '/warehouse/assignDriver',
    method: 'post',
    data
  })
}
//  修改物流人员
export function warehouseUpdate(data) {
  return request({
    url: '/warehouse/update',
    method: 'post',
    data
  })
}


//   物流单
//   物流人员列表
export function freightDriverList(data) {
    return request({
      url: '/freight/driver/list',
      method: 'post',
      data
    })
  }

  // 物流单列表
export function freinghtBbillList(data) {
    return request({
      url: '/freinght/bill/list',
      method: 'post',
      data
    })
  }
// 物流单列表  导出
export function exportFreinghtList(data) {
  return request({
    url: '/freinght/bill/export ',
    method: 'post',
    data,
    responseType: 'arraybuffer',
  })
}


  // 详情

  export function logisticsOrderDetail(data) {
    return request({
      url: '/freinght/order/logistics/detail',
      method: 'post',
      data
    })
  }

  // 凭证
  export function orderMedia(data) {
    return request({
      url: '/freinght/order/media',
      method: 'post',
      data
    })
  }

  // 中转仓合并打印
  export function warehousePrint(data) {
    return request({
      url: '/warehouse/print',
      method: 'post',
      data
    })
  }
  // 热力图添加区域
  export function addArea(data) {
    return request({
      url: '/Thermodynamic/addArea',
      method: 'post',
      data
    })
  }
  // 热力图添加区域
  export function queryArea(data) {
    return request({
      url: '/Thermodynamic/queryArea',
      method: 'post',
      data
    })
  }
  // 热力图添加区域
  export function getOrderLagLng(data) {
    return request({
      url: '/Thermodynamic/getOrderLagLng',
      method: 'post',
      data
    })
  }

//物流扫码查询
export function checkOutRegist(data) {
  return request({
    url: '/order/freightOutShortCheck',
    method: 'post',
    data
  })
}

  //物流扫码提交
export function submitOutRegist(data) {
  return request({
    url: '/order/freightOutRegist',
    method: 'post',
    data
  })
}
//导出揽件确认清单
export function freinghtBillDetailByReceiver(data) {
  return request({
    url: '/freinght/bill/freinghtBillDetailByReceiver/export',
    method: 'post',
    responseType: 'arraybuffer',
    data:data
  })
}
//导出揽件确认清单
export function freinghtBillBeforeAssign(data) {
  return request({
    url: '/freinght/bill/freinghtBillTask/export',
    method: 'post',
    responseType: 'arraybuffer',
    data:data
  })
}


//物流改造
/*打印配货单*/
export function submitDistribution(data) {
  return request({
    url: '/warehouse/printDistribution',
    method: 'post',
    data
  })
}
/*打印物流配货单-司机  2024.05.15新增*/
export function getDriverDistribution(data) {
  return request({
    url: '/warehouse/printDeliveryNoteByDriver',
    method: 'post',
    data
  })
}
/*导出物流配货单-司机  2024.05.15新增*/
export function exportDriverDistribution(data) {
  return request({
    url: '/warehouse/printDeliveryNoteByDriver/export',
    method: 'post',
    responseType: 'arraybuffer',
    data
  })
}

/*导出配货单*/
export function exportDistribution(data) {
  return request({
    url: '/warehouse/distribution/export',
    method: 'post',
    responseType: 'arraybuffer',
    data
  })
}
/*打印发货汇总单*/
export function printDeliverySummary(data) {
  return request({
    url: '/warehouse/printDeliverySummary',
    method: 'post',
    data
  })
}
/*导出发货汇总单*/
export function exportDeliverySummary(data) {
  return request({
    url: '/warehouse/deliverySummary/export',
    method: 'post',
    responseType: 'arraybuffer',
    data
  })
}
//打印物流派送单
export function printFreightList(data) {
  return request({
    url: '/warehouse/freight/selectShippingList',
    method: 'post',
    data
  })
}
//打印小票
export function newPrintTicket(data) {
  return request({
    url: '/order/getOutboundCollectTicket',
    method: 'post',
    data
  })
}
//导出小票
export function exportFreightList(data) {
  return request({
    url: '/warehouse/freight/exportShippingList',
    method: 'post',
    responseType: 'arraybuffer',
    data
  })
}

//物流派送清单  获取所有司机
export function getAllDriver(data) {
  return request({
    url: '/freight/driver/hasOrder',
    method: 'post',
    data
  })
}

//批量修改物流人员
export function lotUpdateDriver(data) {
  return request({
    url: '/warehouse/batchUpdateDriver',
    method: 'post',
    data
  })
}
//修改物流人员校验是否重复修改
export function checkUpdateDriver(data) {
  return request({
    url: '/warehouse/batchUpdateDriverCheck',
    method: 'post',
    data
  })
}




//获取发货仓
export function getAllWarehouse(data) {
  return request({
    url: '/warehouse/list',
    method: 'post',
    data
  })
}
// 补打派送清单 导出
export function exportPrintDispatch(data) {
  return request({
    url: '/warehouse/freight/snapshot/export',
    method: 'post',
    responseType: 'arraybuffer',
    data
  })
}
// 补打派送清单 列表
export function getPrintDispatchList(data) {
  return request({
    url: '/warehouse/freight/snapshot/list',
    method: 'post',
    data
  })
}
// 补打派送清单 打印
export function printDispatchListData(data) {
  return request({
    url: '/warehouse/freight/snapshot/print',
    method: 'post',
    data
  })
}
// 仓库提货单  导出
export function exportFmcgData(data) {
  return request({
    url: '/warehouse/freight/exportShopBillings',
    method: 'post',
    responseType: 'arraybuffer',
    data
  })
}
// 仓库提货单  list
export function getFmcgData(data) {
  return request({
    url: '/warehouse/freight/queryExportShopBillingsData',
    method: 'post',
    data
  })
}

// 快捷分配  list
export function getWaitDistributionAddressShopList(data) {
  return request({
    url: '/warehouse/order/waitDistributionAddressShopList',
    method: 'post',
    data
  })
}

// 管理台快捷分配-确认发车(分配给物流人员)
export function warehouseQuickStart(data) {
  return request({
    url: '/warehouse/quickStart',
    method: 'post',
    data
  })
}

// 管理台商品订单物流明细
export function orderLogistics(data) {
  return request({
    url: '/freinght/order/info',
    method: 'post',
    data
  })
}

//管理台商品订单物流明细导出
export function orderLogisticsExport(data) {
  return request({
    url: '/freinght/order/info/export',
    method: 'post',
    data,
    responseType: 'arraybuffer'
  })
}

//获取用户地址
export function getAddressList(data) {
  return request({
    url: '/warehouse/order/addressFixList',
    method: 'post',
    data
  })
}

//修改用户地址
export function updateAddress(data) {
  return request({
    url: '/warehouse/order/addressFix',
    method: 'post',
    data
  })
}

//已分配司机订单
export function freightDriverRecheckList(data) {
  return request({
    url: '/freightDriverRecheck/webList',
    method: 'post',
    data
  })
}

//已分配待确认-确认
export function recheckConfirm(data) {
  return request({
    url: '/freightDriverRecheck/confirm',
    method: 'post',
    data
  })
}


//已分配待确认明细列表
export function detailList(data) {
  return request({
    url: '/freightDriverRecheck/detailList',
    method: 'post',
    data
  })
}


//已分配待确认-待发货明细列表
export function unOutboundDetailList(data) {
  return request({
    url: '/freightDriverRecheck/unOutboundDetailList',
    method: 'post',
    data
  })
}

//删除
export function recheckDelete(data) {
  return request({
    url: '/freightDriverRecheck/delete',
    method: 'post',
    data
  })
}

// 新物流派送清单打印功能
export function selectShippingList(data) {
  return request({
    url: '/freightDriverRecheck/selectShippingList',
    method: 'post',
    data
  })
}

// 新物流派送清单导出功能
export function exportShippingList(data) {
  return request({
    url: '/freightDriverRecheck/exportShippingList',
    method: 'post',
    data,
    responseType: 'arraybuffer'
  })
}

//已分配司机订单详情修改司机
export function updateDriver(data) {
  return request({
    url: '/freightDriverRecheck/updateDriver',
    method: 'post',
    data
  })
}

//修改预分配司机
export function updatePreDriver(data) {
  return request({
    url: '/freightDriverRecheck/updatePreDriver',
    method: 'post',
    data
  })
}

// 副食水果发货统计导出
export function JS30dExport(data) {
  return request({
    url: '/order/JS30dExport?endTime=' + data.endTime,
    method: 'get',
    data,
    responseType: 'arraybuffer',
  })
}

//导出点位商品明细
export function exportLocationCode(data) {
  return request({
    url: '/warehouse/freight/exportLocationCode',
    method: 'post',
    responseType: 'arraybuffer',
    data
  })
}

//打印点位商品明细列表
export function printLocationCodeList(data) {
  return request({
    url: '/warehouse/freight/printLocationCodeList',
    method: 'post',
    data
  })
}

//导出汇总商品点位明细
export function exportLocationCodeForShop(data) {
  return request({
    url: '/warehouse/freight/exportLocationCodeForShop',
    method: 'post',
    responseType: 'arraybuffer',
    data
  })
}

//新导出汇总商品点位明细
export function newExportLocationCodeForShop(data) {
  return request({
    url: '/warehouseReport/freight/exportLocationCodeForShop',
    method: 'post',
    responseType: 'arraybuffer',
    data
  })
}

//导出商户发货商品汇总
export function exportLocationCodeForTotal(data) {
  return request({
    url: '/warehouse/freight/exportLocationCodeForTotal',
    method: 'post',
    responseType: 'arraybuffer',
    data
  })
}

//新导出商户发货商品汇总
export function newExportLocationCodeForTotal(data) {
  return request({
    url: '/warehouseReport/freight/exportLocationCodeForTotal',
    method: 'post',
    responseType: 'arraybuffer',
    data
  })
}

//打印汇总商品点位明细
export function exportLocationCodeForShopList(data) {
  return request({
    url: '/warehouse/freight/exportLocationCodeForShopList',
    method: 'post',
    data
  })
}

//新打印汇总商品点位明细
export function newExportLocationCodeForShopList(data) {
  return request({
    url: '/warehouseReport/freight/exportLocationCodeForShopList',
    method: 'post',
    data
  })
}

//打印商户发货商品汇总
export function exportLocationCodeForTotalList(data) {
  return request({
    url: '/warehouse/freight/exportLocationCodeForTotalList',
    method: 'post',
    data
  })
}

//新打印商户发货商品汇总
export function newExportLocationCodeForTotalList(data) {
  return request({
    url: '/warehouseReport/freight/exportLocationCodeForTotalList',
    method: 'post',
    data
  })
}

//打印监察专用-商户汇总商品统计
export function merchantProductStatistics(data) {
  return request({
    url: '/warehouse/merchantProductStatistics',
    method: 'post',
    data
  })
}

//导出监察专用-商户汇总商品统计
export function exportMerchantProductStatistics(data) {
  return request({
    url: '/warehouse/exportMerchantProductStatistics',
    method: 'post',
    responseType: 'arraybuffer',
    data
  })
}

//自定义商户组合列表
export function shopCombList(data) {
  return request({
    url: '/shopCustom/list',
    method: 'post',
    data
  })
}

//新增自定义商户组合
export function addShopComb(data) {
  return request({
    url: '/shopCustom/add',
    method: 'post',
    data
  })
}


//修改自定义商户组合
export function updateShopComb(data) {
  return request({
    url: '/shopCustom/update',
    method: 'post',
    data
  })
}

//删除自定义商户组合
export function deleteShopComb(data) {
  return request({
    url: '/shopCustom/delete',
    method: 'post',
    data
  })
}

//自定义商户组合详情
export function shopCombDetail(data) {
  return request({
    url: '/shopCustom/detail',
    method: 'post',
    data
  })
}

// 修正用户地址审核列表
export function auditList(data) {
  return request({
    url: '/addressAudit/webList',
    method: 'post',
    data
  })
}

// 用户地址审核
export function audit(data) {
  return request({
    url: '/addressAudit/audit',
    method: 'post',
    data
  })
}





// WEBPACK FOOTER //
// ./src/api/logistics.js